export const mainBannerModel = {
    show_main_banner: false,
    desktop_url: null,
    mobile_url: null,
    logo_image_url: null,
    page_title: null,
    title: null,
    countdown_text: null,
    registration_button_title: null,
    registration_button_url: null
}

export const aboutAvoksinTrailModel = {
    show_about: false,
    desktop_url: null,
    mobile_url: null,
    title: null,
    description: null,
    date: null,
    location: null,
    slider_images: []
}

export const mindBodyEnvironmentModel = {
    show_mbe: false,
    banners: [{
        id: 'banner',
        desktop_url: null,
        mobile_url: null,
        title: null
    }],
    delete_ids: []
}

export const mainEventsModel = {
    show_main_events: false,
    desktop_url: null,
    mobile_url: null,
    title: null,
    description: null,
    images: [{
        id: 'image',
        title: null,
        description: null,
        image_url: null
    }],
    delete_ids: []
}

export const raceCategoryModel = {
    show_race_category: false,
    desktop_url: null,
    mobile_url: null,
    title: null,
    logo_url: null,
    distance: null,
    elevation: null,
    itra_point: null,
    cutoff: null,
    registration_text: null,
    registration_url: null,
    facility_text: null,
    facilities: [{
        id: 'facilities',
        title: null,
        image_url: null
    }],
    delete_ids: []
}

export const partnerAndSponsorsModel = {
    show_partners_and_sponsors: false,
    desktop_url: null,
    mobile_url: null,
}
